import { actionCreators as documentEditorActionCreators } from "Areas/Documents/documentEditorPanel";
import { actionCreators as projectEditorActionCreators } from "Areas/Projects/projectEditorPanel";
import projectsActionCreators from "Areas/Projects/redux/actionCreators";
import { buildReduxAccessLevelKey } from "Areas/SharedFeatures/accessLevels/redux/selectors";
import { actionCreators as accessLevelsEditorActionCreators } from "Areas/SharedFeatures/accessLevelsEditorPanel";
import workSpaceRoutingKeys from "Areas/WorkSpaces/routingKeys";
import { ACCESS_LEVEL_ENTITY } from "Common/dictionaries/accessLevelEntity";
import { Permissions, security } from "Common/permissions";
import { routesAndPagesMap } from "Common/routingUtils";
import isUndefined from "lodash/isUndefined";
import { connect } from "react-redux";
import ProjectDetails from "./projectDetails";
import actionCreators from "./redux/actionCreators";
import { getData, getInProgress, getProjectId, getTab } from "./redux/selectors";
const canEditProject = security.isAllowed([Permissions.ProjectsEdit]);
const canEditDocuments = security.isAllowed([Permissions.DocumentsEdit]);
const canDeleteProject = security.isAllowed([Permissions.ProjectsDelete]);
const canViewDocuments = security.isAllowed([Permissions.DocumentsView]);
const canViewTasks = security.isAllowed([Permissions.TasksView]);
const canViewSummaryReports = security.isAllowed([Permissions.SummaryReportsView]);
const mapStateToProps = (state) => ({
    projectId: getProjectId(state),
    inProgress: getInProgress(state),
    data: getData(state),
    tab: getTab(state),
    canEditProject,
    canDeleteProject,
    canViewDocuments,
    canViewTasks,
    canViewSummaryReports,
    canEditDocuments
});
const mapDispatchToProps = (dispatch) => ({
    onInitialized: (projectId) => dispatch(actionCreators.getProject(projectId)),
    onOpenProjectEditorPanel: (projectId) => dispatch(projectEditorActionCreators.setProjectId(projectId)),
    onDeleteProject: (projectId, workSpaceId) => {
        Promise.resolve(dispatch(projectsActionCreators.deleteProject(projectId, workSpaceId))).then((promiseResult) => {
            var _a;
            if (isUndefined(promiseResult === null || promiseResult === void 0 ? void 0 : promiseResult.response))
                return;
            window.location.href =
                (_a = routesAndPagesMap.getPath(workSpaceRoutingKeys.WORK_SPACE, workSpaceId)) !== null && _a !== void 0 ? _a : routesAndPagesMap.getDefaultHref();
        });
    },
    onOpenDocumentCreatorPanel: (projectId) => dispatch(documentEditorActionCreators.setCreateNewDocument(projectId)),
    onOpenAccessLevelsEditorPanel: (projectId) => dispatch(accessLevelsEditorActionCreators.setAccessLevelsKey(buildReduxAccessLevelKey(projectId, ACCESS_LEVEL_ENTITY.PROJECT))),
    onChangeTab: (tab) => dispatch(actionCreators.setTab(tab))
});
export default connect(mapStateToProps, mapDispatchToProps)(ProjectDetails);
